import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from './hooks';
import { Link } from 'react-router-dom';

import {
  TopBarContainer,
  SideNavContainer,
  BreadcrumbContainer,
} from './components/Dashboard/';

import {
  Layout,
  PageNavContainer,
  MainContainer,
  PageNavLeftContainer,
  PageNavRightContainer,
} from './views//Styles';


// import { allAuctionType } from '../../../data/auctionTypes';

/*
FIXME: See to do comments below. There is a lot of repetition 
across the view components when a lot of this can be consolidated 
and improve the support and maintainability of the system.
*/


const AppNew = observer(({ breadcrumbs, children }) => {

    // TODO: Move this with the TopBarContainer component
  const {
    UIStore: { headerText, setHeaderText },
    DashboardStore: { connected },
    AuthStore: { memberName },
  } = useStores();

  // TODO: Pass this information in as props, but will reside at the same level as the AuctionStateContainer
//   const [auctionState, setAuctionState] = useState(allAuctionType);
//   const onAuctionStateChanged = (data) => setAuctionState(data);
  
  
  // TODO: Pass this data in as prop
//   const items = [
//     { to: '/dashboard', label: 'Dashboard' },
//     {
//       // to: '/Auctions',
//       label: 'Auctions',
//     },
//   ];


    return (
        <>
            <Layout>
      {/* TODO: TopBarContainer, SideNavContainer, PageNavContainer 
      can all be parent components. Pass filter components, such as 
      Selection in as a prop (Composition) 
      
      Also, we are losing the authenticated user name and moving this 
      up a level should help persist across pages.
      */}
      <TopBarContainer
        connected={connected}
        // auctionAndLaneName={auctionState?.text}
        // auctionAndLaneName={headerText}
        // title={`Auctions`}
        // laneName={`auctionLaneName`}
        memberName={memberName}
        showLogout
      />
      <SideNavContainer />
      <PageNavContainer>
        <PageNavLeftContainer>
          {/* TODO: Refactor into component */}
          <BreadcrumbContainer>
            {breadcrumbs?.map(({ to, label }) =>
              to ? (
                <Link key={to} to={to}>
                  {label}
                </Link>
              ) : (
                label
              ),
            )}
          </BreadcrumbContainer>
        </PageNavLeftContainer>

        <PageNavRightContainer>
          {/* <Selection
            onChange={onAuctionStateChanged}
            title="Views"
            options={auctionTypes}
            defaultValue={allAuctionType.value}
            // style={{ paddingRight: '50px' }}
          /> */}
        </PageNavRightContainer>
      </PageNavContainer>
      <MainContainer>
        {/* TODO: this can come into component as the children prop */}
        {children}
      </MainContainer>
    </Layout>
        </>
    )
});

export default AppNew;

// // installed dependecies
// import React from 'react';
// import { observer } from 'mobx-react-lite';
// import {
//     Route,
//     BrowserRouter as Router,
//     Redirect,
//     useRouteMatch,
//     useHistory,
//     Switch,
// } from 'react-router-dom';

// // style dependencies
// import { Body, Wrapper } from './layout/Styles'

// // component dependencies
// import { ROUTES } from './shared/constants'
// import Login from './views/login'
// import Dashboard from './views/dashboard';
// import SecuredRoute from './SecuredRoute'
// import PageNotFound from './layout/pageNotFound'

// const App = () => {

//     const match = useRouteMatch();
//     const history = useHistory();

//     return (
//         <Wrapper>
//             <Body>
//                 <Router history={history} basename={process.env.PUBLIC_URL} key={Math.random()}>
//                     <Switch>
//                         <Route exact path='/login' component={Login} />
//                         <Route exact path="/">
//                             <Redirect to={ROUTES.login} />
//                         </Route>
//                         <SecuredRoute path={ROUTES.dashboard} component={Dashboard} />
//                         <Route component={PageNotFound} />
//                     </Switch>
//                 </Router>
//                 {match.isExact && <Redirect to={`${match.url}`} />}
//             </Body>
//         </Wrapper>
//     );
// }

// export default observer(App)
